import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import { CircularProgress } from "@material-ui/core";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch, useSelector } from "react-redux";

export default function UpdateDialog({
  open,
  setOpen,
  rowId,
  setUpdateId,
  children,
}) {
  const user = useSelector((state) => state.user);
  const [showLoader, setShowLoader] = useState(false);
  const handleUpdate = () => {
    setUpdateId(rowId);
    setShowLoader(true);
  };

  const dispatch = useDispatch();

  const handleCancel = () => {
    setUpdateId(-1);
    setOpen(false);
  };

  useEffect(() => {
    if (!open) {
      setShowLoader(false);
    }
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          //setOpen(false);
          //setUpdateId(-1);
          //dispatch({ type: "" });
        }}
      >
        <DialogTitle>Update</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            This will update data on row with id: {rowId}
          </DialogContentText> */}
          {showLoader ? (
            <>
              <br />
              <CircularProgress />
            </>
          ) : (
            <></>
          )}
          <br />
          {children}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} className="cancel-button">
            Cancel
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            onClick={handleUpdate}
            className="blue-button"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
